// extracted by mini-css-extract-plugin
module.exports = {"hero-icon":"heroIcon_hero-icon__1zOPJ"};